export default __webpack_public_path__ + "static/media/publication_bird.a836e03a.png";